import { localize } from '@saviynt/common';

import {
  EO_ROWS_CONSTANT_MAP,
  ROWS_CONSTANT_MAP,
} from '../../../components/ViewControls/RowsFilter/constant';
import { getMessageKey } from '../../../utils/utils';

export const formatFilters = (filters) => {
  // Create an empty object to group by keys
  const groupedFilters = {};
  // Store the translated filter label for each key
  const filterLabelMap = {};

  // Iterate over each filter
  filters?.forEach((filter) => {
    const { key, label, filterLabel } = filter;

    // If the key doesn't exist in the groupedFilters object, add it
    if (!groupedFilters[key]) {
      groupedFilters[key] = [];
    }

    // Store the translated filter label for this key
    if (filterLabel && !filterLabelMap[key]) {
      filterLabelMap[key] = filterLabel;
    }

    // Push the label for this key into the array (avoid duplicates)
    if (!groupedFilters[key].includes(label)) {
      groupedFilters[key].push(label);
    }
  });

  // Format the output as a string, using translated filterLabel if available
  return Object.keys(groupedFilters)
    .map(
      (key) =>
        `${filterLabelMap[key] || key} : ${groupedFilters[key].join(', ')}`
    )
    .join(', ');
};

export const formatRows = (isEOCampaign, rows) => {
  const rowsName = rows?.map((item) => {
    if (isEOCampaign) return EO_ROWS_CONSTANT_MAP[item];

    return ROWS_CONSTANT_MAP[item];
  });

  return `ROWS: ${rowsName?.join(', ')}`;
};

export const MANDATORY_COLUMNS = [
  'User_LABEL',
  'Account_LABEL',
  'Ent_LABEL',
  'Role_LABEL',
  'Ent2_LABEL',
];

export const EO_MANDATORY_COLUMNS = [
  'User_LABEL',
  'Account_LABEL',
  'Ent_LABEL',
  'Role_LABEL',
  'Ent2_LABEL',
];

const MANDATORY_COLUMNS_MSG_KEY = {
  'User_LABEL.ATTESTATIONS': 'User_LABEL.ATTESTATIONS',
  'Account_LABEL.ATTESTATIONS': 'Account_LABEL.ATTESTATIONS',
  'Role_LABEL.ATTESTATIONS': 'Role_LABEL.ATTESTATIONS',
  'Ent_LABEL.ATTESTATIONS': 'Ent_LABEL.ATTESTATIONS',
  'Ent2_LABEL.ATTESTATIONS': 'Ent2_LABEL.ATTESTATIONS',
};

// Helper function to get label for a column
export const getColumnLabel = (column, messagesArray, internationalization) =>
  messagesArray[MANDATORY_COLUMNS_MSG_KEY[column]] ||
  messagesArray[column] ||
  localize(internationalization, getMessageKey(column?.split('.')[0]));

const COLUMN_KEY_MAP = {
  User: ['User_LABEL'],
  Role: ['Role_LABEL'],
  Account: ['Account_LABEL'],
  Entitlement: ['Ent_LABEL'],
};

const EO_COLUMN_KEY_MAP = {
  Account: ['Account_LABEL'],
  Entitlement: ['Ent_LABEL'],
  'Child Entitlement': ['Ent2_LABEL'],
};

// Fixed columns for Export
export const DEFAULT_PROPERTIES = {
  User: {
    User_LABEL: 'User_LABEL.ATTESTATIONS',
  },
  Entitlement: {
    Ent_LABEL: 'Ent_LABEL.ATTESTATIONS',
  },
  Account: {
    Account_LABEL: 'Account_LABEL.ATTESTATIONS',
  },
  Role: {
    Role_LABEL: 'Role_LABEL.ATTESTATIONS',
  },
};

// EO campaign - Fixed columns for Export
export const EO_DEFAULT_PROPERTIES = {
  Entitlement: {
    Ent_LABEL: 'Ent_LABEL.ATTESTATIONS',
  },
  Account: {
    Account_LABEL: 'Account_LABEL.ATTESTATIONS',
  },
  'Child Entitlement': {
    Ent2_LABEL: 'Ent2_LABEL.ATTESTATIONS',
  },
};

// Helper function to map columns to their label and status
export const mapColumnData = (
  isEOCampaign,
  columns,
  messagesArray,
  internationalization,
  key
) =>
  columns
    ?.map((item) => {
      const columnKey = item?.split('.')[0];

      return {
        id: item,
        label: getColumnLabel(item, messagesArray, internationalization),
        isChecked: true,
        isDisabled: isEOCampaign
          ? EO_COLUMN_KEY_MAP[key]?.includes(columnKey)
          : COLUMN_KEY_MAP[key]?.includes(columnKey),
      };
    })
    .sort((a, b) => b.isDisabled - a.isDisabled);
